
//---TubeRack---------------------------------------------:
export const createFloatingTubeRack= (data) => {
  //data = {id, type}
  return { type: "CREATE_FLOATING_TUBE_RACK", payload: data}
}

export const FloatingTubeRackItem = (item) => {
  return { type: "FLOATING_TUBE_RACK_ITEM", payload: item}
}

export const createFreezer= (data) => {
  // data = {id, type}
  return { type: "CREATE_FREEZER", payload: data}
}

export const setFreezerOpen = (data) => {
  // data = {open}
  return { type: "SET_FREEZER_OPEN", payload: data}
}

export const setFreezerTemp = (data) => {
  // data = {temp}
  return { type: "SET_FREEZER_TEMP", payload: data}
}

export const freezerContainsTubeRack = (data) => {
  //data = {containsTubeRack}
  return { type: "FREEZER_CONTAINS_TUBE_RACK", payload: data }
}


//---FLOATING TUBE RACK------------------------------------------:
export const tubeInWaterBath = (data) => {
  //data = {inWaterBath}
  return { type: "TUBE_IN_WATER_BATH", payload: data }
}

export const tubeInFreezer = (data) => {
  //data = {inFreezer}
  return { type: "TUBE_IN_FREEZER", payload: data }
}

export const setTubesInRack = (data) => {
  //data = {tubes}
  return { type: "SET_TUBES_IN_RACK", payload: data }
}


export const tubeInIce = (data) => {
  //data = {inIce}
  return { type: "TUBE_IN_ICE", payload: data }
}

export const tubeInRack = (data) => {
  //data = {inRack}
  return { type: "TUBE_IN_RACK", payload: data }
}

export const setTubesInIce = (data) => {
  //data = {tubes}
  return { type: "SET_TUBES_IN_ICE", payload: data }
}

export const addTubeToRack = (data) => {
  //data = {type,id} <- of the tube added
  return { type: "ADD_TUBE_TO_RACK", payload: data }
}

export const removeTubeFromRack = (data) => {
  //data = {}
  return { type: "REMOVE_TUBE_FROM_RACK", payload: data }
}

export const removeTubesFromRack = (data) => {
  //data = {}
  return { type: "REMOVE_TUBES_FROM_RACK", payload: data }
}

export const setFloatingTubeRackHeld = (data) => {
  //data = {id, inScene}
  return { type: "SET_FLOATING_TUBE_RACK_HELD", payload: data}
}
//Set whether the flask controls are displayed or not
export const setFloatingTubeRackControlVisibility = (data) => {
  //data = {id, animatingOut}
  return { type: "SET_FLOATING_TUBE_RACK_CONTROLS_VISIBLE", payload: data}
}


export const toggleToolTipControlsForFloatingTubeRack = data => {
  return { type: "SHOW_TOOL_TIP_CONTROLS_FLOATING_TUBE_RACK", payload: data };
};


// //---WATER BATH-----------------------------:

// export const addItemToWaterBath = (data) => {
//   //data = {newItem} newItem = {type, id}
//   return { type: "ADD_ITEM_TO_WATER_BATH", payload: data }
// }

// export const removeItemFromWaterBath = (data) => {
//   //data = {removeItem} removeItem = {type,id}
//   return { type: "REMOVE_ITEM_FROM_WATER_BATH", payload: data }
// }

// export const waterBathOpen = (data) => {
//   // console.log('actionWaterBathOpen: ', data);
//   //data = {open}
//   return { type: "WATER_BATH_OPEN", payload: data }
// }

// export const setWaterBathTime = (data) => {
//   //data = {time}
//   return { type: "SET_WATER_BATH_TIME", payload: data }
// }

// export const waterBathCountdown = (data) => {
//   //data = {timeDiff}
//   return { type: "WATER_BATH_COUNT_DOWN", payload: data }
// }

// export const setWaterBathTemp = (data) => {
//   //data = {temp}
//   return { type: "SET_WATER_BATH_TEMP", payload: data }
// }

// export const waterBathCountdownActive = (data) => {
//   //data = {active}
//   return { type: "WATER_BATH_COUNTDOWN_ACTIVE", payload: data }
// }

// export const waterBathContainsTubeRack = (data) => {
//   //data = {containsTubeRack}
//   return { type: "WATER_BATH_CONTAINS_TUBE_RACK", payload: data }
// }

